import { GenericProvider } from '@/features/game-context/types';
import { agsAdaptor } from '@/features/game-window-integration/providers/generic-provider/payload-adaptors/ags.adaptor';
import { ProviderAdaptor } from '@/features/game-window-integration/providers/generic-provider/payload-adaptors/contracts';
import { flutterStudiosAdaptor } from '@/features/game-window-integration/providers/generic-provider/payload-adaptors/flutter-studios.adaptor';
import { gamecodeAdaptor } from '@/features/game-window-integration/providers/generic-provider/payload-adaptors/gamecode.adaptor';
import { gamingRealmsAdaptor } from '@/features/game-window-integration/providers/generic-provider/payload-adaptors/gaming-realms.adaptor';
import { whiteHatAdaptor } from '@/features/game-window-integration/providers/generic-provider/payload-adaptors/white-hat.adaptor';

/**
 * Registry of all provider adaptors. Add an entry here when wiring up a new
 * provider so that the generic hooks can route messages to it.
 */
export const PROVIDER_ADAPTORS: Record<GenericProvider, ProviderAdaptor> = {
  WHITE_HAT: whiteHatAdaptor,
  GAMECODE: gamecodeAdaptor,
  FLUTTER_STUDIOS: flutterStudiosAdaptor,
  AGS: agsAdaptor,
  GAMING_REALMS: gamingRealmsAdaptor,
};

export type {
  OutboundPayload,
  ProviderAdaptor,
  ReactiveOutboundMessage,
} from '@/features/game-window-integration/providers/generic-provider/payload-adaptors/contracts';
